import React, { useEffect, useState } from "react";
import { FlameIcon } from "lucide-react";
const TOTAL = 100;
export function ScarcityBar() {
  const [left, setLeft] = useState(9);
  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft(l => l > 3 ? l - 1 : l);
    }, 40000);
    return () => window.clearInterval(id);
  }, []);
  const pct = (TOTAL - left) / TOTAL * 100;
  return <div className="w-full rounded-2xl border-2 border-red-200 bg-red-50 p-4" data-id="element-286" data-mp="2b68m9xjqyakt">
      <p className="flex items-center justify-center gap-2 text-center text-[15px] font-extrabold text-red-700" data-id="element-287" data-mp="2g5tm0a6qqmyl">
        <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-288" data-mp="226btbjqbqpjy" />
        Only {left} spots left at the promotional price
      </p>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-red-100" role="progressbar" aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-289" data-mp="275y5dpuf1zr6">
        <div className="h-full rounded-full bg-red-600 transition-[width] duration-300 ease-out" style={{
        width: `${pct}%`
      }} data-id="element-290" data-mp="5d9yn6ikcu6n" />
      </div>
      <p className="mt-2 text-center text-xs font-semibold text-red-700" data-id="element-291" data-mp="2zl9lwb7zpqkg">{Math.round(pct)}% claimed — price returns to normal when the bar is full</p>
    </div>;
}